import React from "react";
import Title from "../../ui/Title";
import CareIndia from "./CareIndia";
import CareBangladesh from "./CareBangladesh";
import CareNepal from "./CareNepal";
import CareIndonesia from "./CareIndonesia";

const CareScenarios = () => {
  return (
    <div id="care-economy-scenarios" className="scroll-mt-24">
      <Title title="Care economy scenarios in the Nooraverse (India, Bangladesh, Indonesia, Nepal)" />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal mt-4">
        <p>
          While the care economy has been defined in a particular way by
          international organizations, different countries have chosen to
          prioritize different aspects of the care economy for their
          interventions. For example, India’s definition of the care economy
          refers to children, adolescents, the elderly, and persons with
          disabilities, while Bangladesh and Nepal have chosen to focus on
          childcare in particular. Indonesia’s roadmap to the care economy
          adopts a phased approach, starting with childcare in the first phase,
          then expanding to the roll-out of policies and regulations, improving
          access to care services and working conditions of care workers, and
          finally, the institutionalization of care service delivery by 2045.
        </p>

        <CareIndia />
        <CareBangladesh />
        <CareIndonesia />
        <CareNepal />
      </div>
    </div>
  );
};

export default CareScenarios;
